<template>
  <main>
    <md-card>
      <md-steppers md-active-step="contract" md-alternative md-linear
                   v-if="isContractRegistration() && !loadDetail">
        <md-step id="email" md-label="メール認証"></md-step>
        <md-step id="apply" md-label="必須事項の入力"></md-step>
        <md-step id="start" md-label="無料トライアルご利用開始"></md-step>
        <md-step id="contract" md-label="本契約の手続き"></md-step>
        <md-step id="startService" md-label="ご利用開始"></md-step>
      </md-steppers>

      <md-card-header>
        <div class="md-title" v-if="fetchDetail">{{isContractRegistration() ? '本契約登録' : '支払方法'}}</div>
      </md-card-header>

      <md-card-content>
        <a @click="backToList()" href="#" v-if="fetchDetail">
          <md-button class="md-raised">
            <md-icon>arrow_back</md-icon>
            <span>戻る</span>
          </md-button>
        </a>
      </md-card-content>

      <loading-spinner v-if="loadDetail"></loading-spinner>
      <md-card-content v-else-if="fetchDetail && errorNotFound()">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <flash-message :errors="errorMessages" v-if="errorMessages.length"></flash-message>
          </div>
        </div>
      </md-card-content>
      <div class="md-layout" v-else-if="fetchDetail">
        <div class="md-layout-item md-size-20 md-small-size-100"></div>
        <div class="md-layout-item md-size-75 md-small-size-100">
          <flash-message :errors="errorMessages" v-if="errorMessages.length"></flash-message>
          <form @submit.prevent="submitForm" novalidate>
            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-100 md-small-size-100"
                     v-if="isContractRegistration()">
                  <label>下記の登録完了をもって、本契約となります。</label>
                </div>
              </div>
            </md-card-content>
            <!-- 登記情報提供サービスIDを認証 -->
            <md-card-header v-if="isContractRegistration()">
              <div class="md-title">登記情報提供サービスIDを認証</div>
            </md-card-header>
            <md-card-content v-if="isContractRegistration()">
              <!-- 登記情報提供サービス-->
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>登記情報提供サービスID</label>
                </div>
                <div class="md-layout-item">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-60">
                      <div class="md-layout md-alignment-center-space-between">
                        <md-field :class="getActivationValidationClass()"
                                  class="md-layout-item">
                          <label>登記情報提供サービスID</label>
                          <md-input :disabled="sending" name="t_service_id" required
                                    v-model="form.t_service_id"/>
                          <span class="md-helper-text">※登記情報提供サービスの利用者IDをご利用ください。管理者ID、一時利用IDはご利用いただけません。</span>
                          <span class="md-error"
                                v-if="getValidationResponseMessage('t_service_id')">{{ getValidationResponseMessage('t_service_id') }}</span>
                          <span class="md-error"
                                v-else-if="!$v.form.t_service_id.required">{{ errors.t_service_id.required }}</span>
                          <span class="md-error"
                                v-else-if="!$v.form.activated.required">{{ unactivatedMessage }}</span>
                        </md-field>
                      </div>
                    </div>
                    <div class="md-layout-item md-size-40">
                      <div class="md-layout md-alignment-center-space-between">
                        <md-icon class="md-checkbox-checked" v-if="form.activated">check_box</md-icon>
                        <md-icon v-else>check_box_outline_blank</md-icon>
                        <md-button :disabled="sending || form.activated" @click="openDialog" class="md-raised md-primary md-layout-item">
                          <span>パスワード入力</span>
                        </md-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </md-card-content>
            <md-card-content v-if="isContractRegistration()" v-show="!form.activated">
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-form-title">
                  以下の項目は登記情報提供サービスのアカウント認証後にご入力ください。
                </div>
              </div>
            </md-card-content>

            <!-- 申込内容 -->
            <md-card-header v-if="isContractRegistration()">
              <div class="md-title">申込内容</div>
              <div class="md-corp-num">適格請求書発行事業者 登録番号：T9-0111-0104-7870</div>
            </md-card-header>
            <md-card-content v-if="isContractRegistration()"
                             :class="{'md-card-content-disabled': contentDisabled()}">
              <!-- 法⼈名-->
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"><label>法⼈名</label></div>
                <div class="md-layout-item">
                  <md-field :class="getValidationClass('corporation.name')">
                    <label>法⼈名</label>
                    <md-input v-model="form.corporation.name" :disabled="sending || disabledByTServiceId()" required></md-input>
                    <span class="md-helper-text">例) 株式会社JON</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('corporation.name')">{{ getValidationResponseMessage('corporation.name') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.corporation.name.required">{{ errors.corporation.name.required }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"></div>
                <div class="md-layout-item">
                  <span class="md-caption">
                    ※法人名は省略せずにご入力ください。×(株)　〇株式会社<br>
                    ※個人のお客様はお手数ですが、法人名、ご担当者名ともお名前をご入力ください。
                  </span>
                </div>
              </div>

              <!-- 支店名 -->
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"><label>支店名</label></div>
                <div class="md-layout-item md-size-40 md-small-size-100">
                  <md-field :class="getValidationClass('corporation.branch_name')">
                    <label>支店名</label>
                    <md-input :disabled="sending || disabledByTServiceId()" v-model="form.corporation.branch_name"></md-input>
                    <span class="md-helper-text">例) 上野オフィス、上野支店</span>
                    <span class="md-error" v-if="getValidationResponseMessage('corporation.branch_name')">
                      {{ getValidationResponseMessage('corporation.branch_name') }}
                    </span>
                  </md-field>
                </div>
                <div class="md-layout-item"></div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"></div>
                <div class="md-layout-item">
                  <span class="md-caption">
                    ※支店名等がある場合は、必ずご入力ください。
                  </span>
                </div>
              </div>

              <!-- 所在地-->
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"><label>所在地</label></div>
                <div class="md-layout-item md-size-40 md-small-size-100">
                  <md-field :class="getValidationClass('corporation.postal')">
                    <label>郵便番号</label>
                    <span class="md-prefix">〒</span>
                    <md-input :disabled="sending || disabledByTServiceId()" required v-model="form.corporation.postal"></md-input>
                    <span class="md-helper-text">例) 1076231、ハイフン不要</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('corporation.postal')">{{ getValidationResponseMessage('corporation.postal') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.corporation.postal.required">{{ errors.corporation.postal.required }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.corporation.postal.numeric">{{ errors.corporation.postal.numeric }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.corporation.postal.minLength">{{ errors.corporation.postal.minLength }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.corporation.postal.maxLength">{{ errors.corporation.postal.maxLength }}</span>
                  </md-field>
                </div>
                <div class="md-layout-item"></div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-size-30 md-small-size-50">
                  <md-field :class="getValidationClass('corporation.pref')">
                    <label>都道府県</label>
                    <md-select id="citySelected" v-model="form.corporation.pref" :disabled="sending || disabledByTServiceId()" required>
                      <md-option v-for="(prefecture,index) in prefectures" :value="prefecture" :key="index">
                        {{ prefecture }}
                      </md-option>
                    </md-select>
                    <span class="md-helper-text">例) 東京都</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('corporation.pref')">{{ getValidationResponseMessage('corporation.pref') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.corporation.pref.required">{{ errors.corporation.pref.required }}</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-40 md-small-size-50">
                  <md-field :class="getValidationClass('corporation.city')">
                    <label>市区町村</label>
                    <md-input v-model="form.corporation.city" type="text" :disabled="sending || disabledByTServiceId()"
                              required></md-input>
                    <span class="md-helper-text">例) 新宿区</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('corporation.city')">{{ getValidationResponseMessage('corporation.city') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.corporation.city.required">{{ errors.corporation.city.required }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-size-40 md-small-size-50">
                  <md-field :class="getValidationClass('corporation.street_name')">
                    <label>町名</label>
                    <md-input v-model="form.corporation.street_name" :disabled="sending || disabledByTServiceId()" required></md-input>
                    <span class="md-helper-text">例) 新小川町</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('corporation.street_name')">{{ getValidationResponseMessage('corporation.street_name') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.corporation.street_name.required">{{ errors.corporation.street_name.required }}</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-30 md-small-size-50">
                  <md-field :class="getValidationClass('corporation.street_number')">
                    <label>番地</label>
                    <md-input v-model="form.corporation.street_number" :disabled="sending || disabledByTServiceId()" required></md-input>
                    <span class="md-helper-text">例) 5-1</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('corporation.street_number')">{{ getValidationResponseMessage('corporation.street_number') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.corporation.street_number.required">{{ errors.corporation.street_number.required }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"></div>
                <div class="md-layout-item">
                  <md-field :class="getValidationClass('corporation.etc')">
                    <label>建物名・部屋番号等</label>
                    <md-input v-model="form.corporation.etc" :disabled="sending || disabledByTServiceId()"></md-input>
                    <span class="md-helper-text">例) ニューリバー51 4F</span>
                  </md-field>
                </div>
              </div>

              <!-- ご担当者名-->
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"><label>ご担当者名</label></div>
                <div class="md-layout-item md-size-35 md-small-size-50">
                  <md-field :class="getValidationClass('account.name_last')">
                    <label>姓</label>
                    <md-input v-model="form.account.name_last" :disabled="sending || disabledByTServiceId()" required></md-input>
                    <span class="md-helper-text">例) JON</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('account.name_last')">{{ getValidationResponseMessage('account.name_last') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.account.name_last.required">{{ errors.account.name_last.required }}</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-35 md-small-size-50">
                  <md-field :class="getValidationClass('account.name_first')">
                    <label>名</label>
                    <md-input v-model="form.account.name_first" :disabled="sending || disabledByTServiceId()" required></md-input>
                    <span class="md-helper-text">例) 太郎</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('account.name_first')">{{ getValidationResponseMessage('account.name_first') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.account.name_first.required">{{ errors.account.name_first.required }}</span>
                  </md-field>
                </div>
              </div>

              <!-- ご連絡先-->
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"><label>ご連絡先</label></div>
                <div class="md-layout-item">
                  <md-field :class="getValidationClass('account.email')">
                    <label>メールアドレス</label>
                    <md-input name="mail" v-model="form.account.email" required placeholder="例）jontaro@jon.co.jp"
                              :disabled="true"/>
                    <span class="md-helper-text">例) jontaro@jon.co.jp</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('account.email')">{{ getValidationResponseMessage('account.email') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.account.email.required">{{ errors.account.email.required }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"><label></label></div>
                <div class="md-layout-item">
                  <span class="md-caption">※メールアドレスは本契約後に変更が可能です。</span>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-size-40 md-small-size-100">
                  <md-field :class="getValidationClass('account.tel')">
                    <label>電話番号</label>
                    <md-input :disabled="sending || disabledByTServiceId()" name="phone" required v-model="form.account.tel"/>
                    <span class="md-helper-text">例) 0332691220</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('account.tel')">{{ getValidationResponseMessage('account.tel') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.account.tel.required">{{ errors.account.tel.required }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.account.tel.numeric">{{ errors.account.tel.numeric }}</span>
                  </md-field>
                </div>
              </div>
            </md-card-content>

            <!-- 決済方法 -->
            <md-card-header>
              <div class="md-title">決済方法</div>
            </md-card-header>
            <md-card-content
                :class="{'md-card-content-disabled': contentDisabled()}">
              <!-- 支払情報の名称 -->
              <div class="md-layout md-gutter" v-show="showPaymentLabel()">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>支払情報の名称</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('label')">
                    <label>支払情報の名称</label>
                    <md-input name="label" v-model="form.label" required autofocus :disabled="sending || disabledByTServiceId()"></md-input>
                    <span class="md-helper-text">※ご自由にご登録ください。例：振込用、クレカ用　など</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('label')">{{ getValidationResponseMessage('label') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.label.required">{{ errors.label.required }}</span>
                  </md-field>
                </div>
              </div>

              <!-- 決済方法 -->
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>決済方法</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-radio v-model="form.bill_method" v-bind:key="'building-method-key-' + billingMethod"
                            v-for="(billingMethodName, billingMethod) in billingMethods"
                            :value="billingMethod" required @change="onChangeBillingMethod" name="billingMethod"
                            :disabled="sending || disabledByTServiceId()">
                    {{ billingMethodName }}
                  </md-radio>
                </div>
              </div>

              <!-- カード情報 -->
              <div class="md-layout md-gutter" v-if="$props.id && showCardInformation() && ! showCardInfoBlock">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-small-size-100">
                  <p class="md-body-2">現在ご登録中のカード番号<br/>{{ paymentMethodCardNo() }}</p>
                </div>
              </div>
              <div v-if="$props.id && showCardInformation() && ! showCardInfoBlock" class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-small-size-100">
                  <md-button class="md-raised" @click="showCardInfoBlock = true">
                    <md-icon>edit</md-icon>
                    <span>カード情報を変更する</span>
                  </md-button>
                </div>
              </div>
              <div class="md-layout md-gutter" v-if="showCardInformation() && showCardInfoBlock">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>カード情報</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('cardNumber')">
                    <label>カード情報</label>
                    <md-input name="cardNumber" required type="card" v-model="form.cardNumber"
                              :disabled="sending || disabledByTServiceId()" maxlength="20"></md-input>
                    <span class="md-helper-text">例) 1111222233334444、※ "-" ハイフンは不要です</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('cardNumber')">{{ getValidationResponseMessage('cardNumber') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.cardNumber.required">{{ errors.cardNumber.required }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.cardNumber.numeric">{{ errors.cardNumber.numeric }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.cardNumber.minLength">{{ errors.cardNumber.minLength }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.cardNumber.maxLength">{{ errors.cardNumber.maxLength }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter" v-if="showCardInformation() && showCardInfoBlock">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100"></div>
                <div class="md-layout md-layout-item md-size-35 md-small-size-100">
                  <div class="md-layout md-layout-item md-alignment-center-left md-size-40">
                    <label>有効期限</label>
                  </div>
                  <md-field class="md-layout-item md-size-50" :class="getValidationClass('cardExpireMonth')">
                    <md-select name="cardExpireMonth" v-model="form.cardExpireMonth" required :disabled="sending || disabledByTServiceId()">
                      <md-option v-for="(month, index) in months" :value="month" :key="index">
                        {{month}}
                      </md-option>
                    </md-select>
                    <span class="md-error"
                          v-if="!$v.form.cardExpireMonth.required">{{ errors.cardExpireMonth.required }}</span>
                  </md-field>
                  <div class="md-layout md-layout-item md-alignment-center md-size-5">
                    <label>月</label>
                  </div>
                </div>
                <div class="md-layout md-layout-item md-size-35 md-small-size-100">
                  <md-field class="md-layout-item md-size-50" :class="getValidationClass('cardExpireYear')">
                    <md-select name="cardExpireYear" v-model="form.cardExpireYear" required :disabled="sending || disabledByTServiceId()">
                      <md-option v-for="year in years()" :value="year" :key="'year-' + year">
                        {{year}}
                      </md-option>
                    </md-select>
                    <span class="md-error"
                          v-if="!$v.form.cardExpireYear.required">{{ errors.cardExpireYear.required }}</span>
                  </md-field>
                  <div class="md-layout md-layout-item md-alignment-center md-size-5">
                    <label>年</label>
                  </div>
                </div>
              </div>
              <div class="md-layout md-gutter" v-if="showCardInformation() && showCardInfoBlock">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClass('cardHolder')">
                    <label>名義人（任意）</label>
                    <md-input :disabled="sending || disabledByTServiceId()" name="cardHolder" v-model="form.cardHolder"></md-input>
                    <span class="md-helper-text">例) TARO JON</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('cardHolder')">{{ getValidationResponseMessage('cardHolder') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.cardHolder.cardHolder">{{ errors.cardHolder.cardHolder }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter" v-if="showCardInformation() && showCardInfoBlock">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <md-field :class="getValidationClass('cardSecurityCode')">
                    <label>セキュリティコード（任意）</label>
                    <md-input :disabled="sending || disabledByTServiceId()" maxlength="4" name="cardSecurityCode"
                              v-model="form.cardSecurityCode"></md-input>
                    <span class="md-helper-text">例) 1234</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('cardSecurityCode')">{{ getValidationResponseMessage('cardSecurityCode') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.cardSecurityCode.numeric">{{ errors.cardSecurityCode.numeric }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter" v-if="getValidationResponseMessage('card_token')">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-size-50 md-small-size-100">
                  <flash-message :errors="[getValidationResponseMessage('card_token')]"></flash-message>
                </div>
              </div>
            </md-card-content>

            <!-- 請求書の送付方法 -->
            <md-card-header>
              <div class="md-title">請求書の送付方法</div>
            </md-card-header>
            <md-card-content
                :class="{'md-card-content-disabled': contentDisabled()}">
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>請求書の送付方法</label>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-radio v-for="(billingViaName, billingViaCode) in billingViaWithFee"
                            v-model="form.bill_via" v-bind:key="'billing-via-key-' + billingViaCode"
                            :value="billingViaCode" required name="billingVia"
                            v-if="showViaItem(billingViaCode)" :disabled="sending || disabledByTServiceId()">
                    {{ billingViaName }}
                  </md-radio>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-small-size-100">
                  <span class="md-caption">※クレジットカードでのお支払いの場合は、明細書をメールでお送りします。</span>
                </div>
              </div>

              <!-- ご連絡先-->
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>宛名</label>
                  <span class="md-caption">※請求書の宛名、請求書送付の本文の宛名に記載されます。</span>
                </div>
                <div class="md-layout-item">
                  <md-field :class="getValidationClass('name1')">
                    <label>法人名</label>
                    <md-input v-model="form.name1" required :disabled="sending || disabledByTServiceId()"></md-input>
                    <span class="md-helper-text">例) 株式会社JON　上野オフィス</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('name1')">{{ getValidationResponseMessage('name1') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.name1.required">{{ errors.name1.required }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"></div>
                <div class="md-layout-item">
                  <span class="md-caption">
                    ※法人名は省略せずにご入力ください。×(株)　〇株式会社<br/>
                  </span>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"></div>
                <div class="md-layout-item">
                  <md-field :class="getValidationClass('name2')">
                    <label>部署名</label>
                    <md-input v-model="form.name2" :disabled="sending || disabledByTServiceId()"></md-input>
                    <span class="md-helper-text">例) 経理部</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('name2')">{{ getValidationResponseMessage('name2') }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"></div>
                <div class="md-layout-item">
                  <md-field :class="getValidationClass('name3')">
                    <label>ご担当者名</label>
                    <md-input v-model="form.name3" :disabled="sending || disabledByTServiceId()"></md-input>
                    <span class="md-helper-text">例) JON 太郎</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('name3')">{{ getValidationResponseMessage('name3') }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter check-same-corp"></div>
              <!-- 所在地-->
              <div v-if="form.bill_via !== common.billingViaEmail" class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>所在地</label>
                  <div class="md-layout-item md-size-100" v-show="showAddressCopy()">
                    <md-button class="md-raised md-primary check-same-corp"
                               @click="isSameCorporation = !isSameCorporation">
                      <md-icon>{{ isSameCorporation ? 'check_box' : 'check_box_outline_blank' }}</md-icon>
                      <span>法人情報と同じ</span>
                    </md-button>
                  </div>
                </div>
                <div class="md-layout-item md-size-40">
                  <md-field :class="getValidationClass('postal')">
                    <label>郵便番号</label>
                    <span class="md-prefix">〒</span>
                    <md-input v-model="form.postal" required :disabled="sending || disabledByTServiceId() || isSameCorporation"></md-input>
                    <span class="md-helper-text">例) 1076231、ハイフン不要</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('postal')">{{ getValidationResponseMessage('postal') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.postal.requiredIf">{{ errors.postal.requiredIf }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.postal.numeric">{{ errors.postal.numeric }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter" v-if="form.bill_via !== common.billingViaEmail">
                <div class="md-layout-item md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-size-30 md-small-size-50">
                  <md-field :class="getValidationClass('pref')">
                    <label>都道府県</label>
                    <md-select id="pref" v-model="form.pref" required :disabled="isSameCorporation">
                      <md-option v-for="(pref,index) in prefectures" :value="pref" :key="'pref-' + index">
                        {{ pref }}
                      </md-option>
                    </md-select>
                    <span class="md-helper-text">例) 東京都</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('pref')">{{ getValidationResponseMessage('pref') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.pref.requiredIf">{{ errors.pref.requiredIf }}</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-40 md-small-size-50">
                  <md-field :class="getValidationClass('city')">
                    <label>市区町村</label>
                    <md-input type="text" v-model="form.city" required
                              :disabled="sending || disabledByTServiceId() || isSameCorporation"></md-input>
                    <span class="md-helper-text">例) 新宿区</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('city')">{{ getValidationResponseMessage('city') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.city.requiredIf">{{ errors.city.requiredIf }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter" v-if="form.bill_via !== common.billingViaEmail">
                <div class="md-layout-item md-size-30 md-small-size-100"></div>
                <div class="md-layout-item md-size-40 md-small-size-50">
                  <md-field :class="getValidationClass('street_name')">
                    <label>町名</label>
                    <md-input type="text" v-model="form.street_name" required
                              :disabled="sending || disabledByTServiceId() || isSameCorporation"></md-input>
                    <span class="md-helper-text">例) 新小川町</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('street_name')">{{ getValidationResponseMessage('street_name') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.street_name.requiredIf">{{ errors.street_name.requiredIf }}</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-30 md-small-size-50">
                  <md-field :class="getValidationClass('street_number')">
                    <label>番地</label>
                    <md-input type="text" v-model="form.street_number" required :disabled="sending || disabledByTServiceId()"></md-input>
                    <span class="md-helper-text">例) 5-1</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('street_number')">{{ getValidationResponseMessage('street_number') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.street_number.requiredIf">{{ errors.street_number.requiredIf }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter" v-if="form.bill_via !== common.billingViaEmail">
                <div class="md-layout-item md-size-30 md-small-size-100"></div>
                <div class="md-layout-item">
                  <md-field>
                    <label>建物名・部屋番号等</label>
                    <md-input v-model="form.etc" :disabled="sending || disabledByTServiceId() || isSameCorporation"></md-input>
                    <span class="md-helper-text">例) ニューリバー51</span>
                  </md-field>
                </div>
              </div>
              <!-- メールアドレス-->
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>メールアドレス</label>
                  <div class="md-caption">※請求書送付先に追加できるメールアドレスは10件までです。</div>
                </div>
                <div class="md-layout-item">
                  <md-field :class="getValidationClass('email')">
                    <label>メールアドレス</label>
                    <md-input name="mail" v-model="form.email" required :disabled="sending || disabledByTServiceId()"
                              :readonly="isSameCorporation"/>
                    <span class="md-helper-text">例) jontaro@jon.co.jp</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('email')">{{ getValidationResponseMessage('email') }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.email.required">{{ errors.email.required }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.email.email">{{ errors.email.email }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                </div>
                <div class="md-layout-item">
                  <div class="md-layout-item d-flex" v-for="(additionalAddressItem, index) in form.additionalAddresses"
                       :key="'additionalAddresses_' + index">
                    <div class="md-field d-block" style="padding-top: 0; margin: 0;">
                      <md-field :class="getEmailValidationClass(index)">
                        <label>メールアドレス</label>
                        <md-input name="mail" v-model="form.additionalAddresses[index]" :disabled="sending || disabledByTServiceId()" />
                        <span class="md-helper-text">例) jontaro@jon.co.jp</span>
                        <span class="md-error"
                              v-if="getEmailValidationResponseMessage(index)">{{ getEmailValidationResponseMessage(index) }}</span>
                        <span class="md-error"
                              v-else-if="!$v.form.additionalAddresses.$each[index].email">{{ errors.email.email }}</span>
                        <span class="md-error"
                              v-else-if="!$v.form.additionalAddresses.$each[index].duplicateWith">{{ errors.email.duplicated }}</span>
                        <span class="md-error"
                              v-else-if="!$v.form.additionalAddresses.$each[index].duplicate">{{ errors.email.duplicated }}</span>
                      </md-field>
                    </div>
                    <div class="d-flex align-items-end" style="height: 63px;">
                      <div>
                        <md-icon class="ml-3 pointer" @click.native="addNewEmail(index + 1)">add_circle_outline</md-icon>
                        <!-- show when additionalAddresses >= 10-->
                        <md-tooltip md-direction="top" v-if="form.additionalAddresses.length >= 10">追加できる件数は10件までです。</md-tooltip>
                        <!--hover add button-->
                        <md-tooltip md-direction="top" v-else>メールアドレスの追加</md-tooltip>
                      </div>
                    </div>
                    <div class="d-flex align-items-end" style="height: 63px;">
                      <div>
                        <md-icon class="ml-3 pointer" @click.native="removeThisEmail(index)" v-show="form.additionalAddresses.length > 1">remove_circle_outline</md-icon>
                        <md-tooltip>メールアドレスの削除</md-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- その他-->
              <div class="md-layout md-gutter" v-if="isContractRegistration()">
                <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
                  <label>その他</label></div>
                <div class="md-layout-item">
                  <md-field :class="getValidationClass('reason')">
                    <label>申し込みのきっかけ</label>
                    <md-select v-model="form.contract.reason" :disabled="sending || disabledByTServiceId()" required>
                      <md-option v-for="(reason,index) in contractReason" :value="reason"
                                 :key="'reason-' + index">
                        {{ reason }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
            </md-card-content>

            <!-- 利用規約-->
            <md-card-content v-if="isContractRegistration()"
                             :class="{'md-card-content-disabled': contentDisabled()}">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100">利用規約の確認</div>
                <div class="md-layout-item">
                  <md-button :disabled="sending || disabledByTServiceId()" @click="openTerms" class="md-primary md-raised">
                    <md-icon>list_alt</md-icon>
                    <span>シカクマップ 利用規約</span>
                  </md-button>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"></div>
                <div class="md-layout-item">
                  <md-checkbox :disabled="sending || disabledByTServiceId() || !isReadTerms" class="md-primary" id="checkAccept"
                               v-model="form.apply">
                    上記利用規約に同意します
                  </md-checkbox>
                  <flash-message :errors="[getValidationResponseMessage('apply')]"
                                 v-if="getValidationResponseMessage('apply')"></flash-message>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-30 md-small-size-100"></div>
                <div class="md-layout-item">
                  <p class="md-caption">ご入力いただいた個人情報の取り扱い詳細は<a href="https://www.jon.co.jp/privacy/" rel="noopener"
                                                               target="_blank">プライバシーポリシー</a>をご覧ください。<br/>
                    申し込みをもって、これにご同意いただいたものとみなします。</p>
                </div>
              </div>
            </md-card-content>

            <md-card-actions>
              <div class="md-layout md-alignment-top-center">
                <md-button type="submit" class="md-button md-primary md-raised" :disabled="sending || disabledByTServiceId() || isCardAuthenticating">
                  <md-icon>save</md-icon>
                  <span v-if="isContractRegistration()">確認画面へ</span>
                  <span v-else>登録する</span>
                </md-button>
              </div>
            </md-card-actions>
          </form>
        </div>
      </div>

      <activation-modal :md-active.sync="showDialog" v-bind:t_service_id="form.t_service_id"
                        @close="closeActivationModal" @activationSuccess="activationSuccess"></activation-modal>

      <credit-card3ds-modal
          :isOpen="isOpenCardAuthModal"
          :creditCard3dsUrl="creditCard3dsUrl"
          @close="handleCloseCardAuthModal"
      />

    </md-card>
  </main>
</template>

<script>
  import FlashMessage                                                  from '../../../components/FlashMessage';
  import Common                                                        from '../../../modules/common';
  import CommonMixin                                                   from '../../../mixins/commonMixin';
  import YubinBango                                                    from '../../../modules/yubinbango';
  import {validationMixin}                                             from 'vuelidate'
  import {email, maxLength, minLength, numeric, required, requiredIf,} from 'vuelidate/lib/validators'
  import Validation                                                    from '../../../modules/validation';
  import {
    apiClient as apiClientWithoutToken,
    apiClientWithUserToken as apiClient,
    apiList,
  }                                                                    from '../../../modules/apiClient';
  import GMO                                                           from '../../../modules/gmo';
  import moment                                                        from 'moment';
  import LoadingSpinner                                                from '../../../components/LoadingSpinner';
  import LoadingSpinnerOverlay                                         from '../../../components/LoadingSpinnerOverlay';
  import ActivationModal                                               from '../../../components/ActivationModal';
  import CreditCard3dsModal                                            from "../../../components/CreditCard3dsModal.vue";
  import {mapActions, mapGetters}                                      from 'vuex';

  import _ from 'lodash';

  const duplicateWith    = (mainEmail) => (email) => !mainEmail || !email || mainEmail !== email;
  const duplicateInArray = (emails) => (email) => !email || emails.filter(e => e === email).length <= 1;

  export default {
    name      : "UserPaymentNew",
    components: {LoadingSpinnerOverlay, LoadingSpinner, FlashMessage, ActivationModal, CreditCard3dsModal},
    mixins    : [CommonMixin, validationMixin],
    props     : {
      id: {
        type   : String,
        default: null,
      }
    },
    data      : () => ({
      loadDetail               : false,
      billingMethods           : Common.billingMethods,
      billingViaWithFee        : Common.billingViaWithFee,
      gmoMemberId              : null,
      oldBillMethod            : null,
      form                     : {
        label              : null,
        bill_method        : Common.billingMethodCreditCard,
        cardNumber         : null,
        cardExpireMonth    : null,
        cardExpireYear     : moment().year(),
        cardHolder         : null,
        cardSecurityCode   : null,
        bill_via           : Common.billingViaEmail,
        name1              : null,
        name2              : null,
        name3              : null,
        postal             : null,
        email              : null,
        additionalAddresses: [null],
        pref               : null,
        city               : null,
        street_name        : null,
        street_number      : null,
        etc                : null,
        t_service_id       : null,
        activated          : null,
        contract           : {
          reason: Common.contractReason[0],
        },
        apply              : false,
        corporation        : {
          name         : null,
          branch_name  : null,
          postal       : null,
          pref         : null,
          city         : null,
          street_name  : null,
          street_number: null,
          etc          : null,
        },
        account            : {
          name_last : '',
          name_first: '',
          email     : null,
          tel       : null,
        },
      },
      prefectures              : Common.prefectures,
      months                   : Common.allMonths,
      showCardInfoBlock        : false,
      errors                   : {
        label           : {
          required: Validation.errorMessage(Validation.rules.required, 'paymentLabel'),
        },
        bill_method     : {
          required: Validation.errorMessage(Validation.rules.required, 'paymentBillMethod'),
        },
        cardNumber      : {
          required : Validation.errorMessage(Validation.rules.required, 'paymentCardNumber'),
          minLength: Validation.errorMessage(Validation.rules.minLength, 'paymentCardNumber', 14),
          maxLength: Validation.errorMessage(Validation.rules.maxLength, 'paymentCardNumber', 16),
          numeric  : Validation.errorMessage(Validation.rules.numeric, 'paymentCardNumber'),
        },
        cardExpireMonth : {
          required: Validation.errorMessage(Validation.rules.required, 'paymentCardExpiredMonth'),
        },
        cardExpireYear  : {
          required: Validation.errorMessage(Validation.rules.required, 'paymentCardExpiredYear'),
        },
        cardHolder      : {
          cardHolder: Validation.errorMessage(Validation.rules.cardHolder, 'cardHolder'),
        },
        cardSecurityCode: {
          numeric  : Validation.errorMessage(Validation.rules.numeric, 'paymentCardSecurityCode'),
          maxLength: Validation.errorMessage(Validation.rules.max, 'paymentCardSecurityCode', 4),
        },
        bill_via        : {
          required: Validation.errorMessage(Validation.rules.required, 'paymentBillVia'),
        },
        name1           : {
          required: Validation.errorMessage(Validation.rules.required, 'paymentName1'),
        },
        postal          : {
          requiredIf: Validation.errorMessage(Validation.rules.requiredIf, 'paymentPostal'),
          numeric   : Validation.errorMessage(Validation.rules.numeric, 'paymentPostal'),
          minLength : Validation.errorMessage(Validation.rules.size, 'paymentPostal'),
          maxLength : Validation.errorMessage(Validation.rules.size, 'paymentPostal'),
        },
        pref            : {
          requiredIf: Validation.errorMessage(Validation.rules.requiredIf, 'paymentPref'),
        },
        city            : {
          requiredIf: Validation.errorMessage(Validation.rules.requiredIf, 'paymentCity'),
        },
        street_name     : {
          requiredIf: Validation.errorMessage(Validation.rules.requiredIf, 'paymentStreetName'),
        },
        street_number   : {
          requiredIf: Validation.errorMessage(Validation.rules.requiredIf, 'paymentStreetNumber'),
        },
        email           : {
          required  : Validation.errorMessage(Validation.rules.required, 'paymentEmail'),
          email     : Validation.errorMessage(Validation.rules.email, 'paymentEmail'),
          duplicated: Validation.errorMessage(Validation.rules.duplicatedEmail, 'paymentEmail'),
        },
        t_service_id    : {
          required: Validation.errorMessage(Validation.rules.required, 'tServiceID'),
        },
        apply           : {
          required: Validation.errorMessage(Validation.rules.required, 'apply'),
        },
        corporation     : {
          name         : {
            required: Validation.errorMessage(Validation.rules.required, 'corporationName'),
          },
          postal       : {
            required : Validation.errorMessage(Validation.rules.required, 'corporationPostal'),
            maxLength: Validation.errorMessage(Validation.rules.size, 'corporationPostal', 7),
            minLength: Validation.errorMessage(Validation.rules.size, 'corporationPostal', 7),
            numeric  : Validation.errorMessage(Validation.rules.numeric, 'corporationPostal'),
          },
          pref         : {
            required: Validation.errorMessage(Validation.rules.required, 'corporationAddressPref'),
          },
          city         : {
            required: Validation.errorMessage(Validation.rules.required, 'corporationAddressCity'),
          },
          street_name  : {
            required: Validation.errorMessage(Validation.rules.required, 'corporationStreetName'),
          },
          street_number: {
            required: Validation.errorMessage(Validation.rules.required, 'corporationStreetNumber'),
          },
        },
        account         : {
          name_last : {
            required: Validation.errorMessage(Validation.rules.required, 'accountLastName'),
          },
          name_first: {
            required: Validation.errorMessage(Validation.rules.required, 'accountFirstName'),
          },
          email     : {
            required: Validation.errorMessage(Validation.rules.required, 'corporationEmail'),
            email,
          },
          tel       : {
            required: Validation.errorMessage(Validation.rules.required, 'corporationTel'),
            numeric : Validation.errorMessage(Validation.rules.numeric, 'corporationTel'),
          },
        },
      },
      cardToken                : null,
      paymentMethods           : null,
      showDialog               : false,
      oldTServiceId            : null,
      unactivatedMessage       : Common.messages.activation.unactivated,
      checkScroll              : false,
      isReadTerms              : false,
      fetchAuthAccount         : false,
      isSameCorporation        : false,
      common                   : Common,
      isTrialUser              : false,
      isTrialEnd               : false,
      contractReason           : Common.contractReason,
      verify                   : false,
      toggleAdditionalAddresses: true,
      isCardAuthenticating     : false, // 本人認証中かどうか
      pendingCardToken         : null,  // 本人認証前のカードトークン
      enrollCardToken          : null,  // 登録用カードトークン
      creditCard3dsUrl         : null,  // 本人認証用のURL
      authorizedCardTokens     : {},    // 本人認証済のカードトークン
    }),
    validations() {
      const validations = {
        form: {
          label              : {
            required,
          },
          bill_method        : {
            required,
          },
          bill_via           : {
            required,
          },
          name1              : {
            required,
          },
          postal             : {
            required : requiredIf(() => {
              return this.form.bill_via !== Common.billingViaEmail;
            }),
            numeric,
            minLength: minLength(7),
            maxLength: maxLength(7),
          },
          pref               : {
            required: requiredIf(() => {
              return this.form.bill_via !== Common.billingViaEmail;
            }),
          },
          city               : {
            required: requiredIf(() => {
              return this.form.bill_via !== Common.billingViaEmail;
            }),
          },
          street_name        : {
            required: requiredIf(() => {
              return this.form.bill_via !== Common.billingViaEmail;
            }),
          },
          street_number      : {
            required: requiredIf(() => {
              return this.form.bill_via !== Common.billingViaEmail;
            }),
          },
          email              : {
            required,
            email,
          },
          cardNumber         : {
            required,
            minLength: minLength(14),
            maxLength: maxLength(16),
            numeric,
          },
          cardExpireMonth    : {
            required,
          },
          cardExpireYear     : {
            required,
          },
          cardHolder         : {
            cardHolder: Validation.cardHolder,
          },
          cardSecurityCode   : {
            numeric,
          },
          t_service_id       : {
            required: requiredIf(this.isContractRegistration),
          },
          activated          : {
            required: requiredIf(this.isContractRegistration),
          },
          apply              : {
            required: requiredIf(this.isContractRegistration),
          },
          contract           : {},
          corporation        : {
            name         : {
              required: requiredIf(this.isContractRegistration),
            },
            postal       : {
              required : requiredIf(this.isContractRegistration),
              numeric,
              maxLength: maxLength(7),
              minLength: minLength(7),
            },
            pref         : {
              required: requiredIf(this.isContractRegistration),
            },
            city         : {
              required: requiredIf(this.isContractRegistration),
            },
            street_name  : {
              required: requiredIf(this.isContractRegistration),
            },
            street_number: {
              required: requiredIf(this.isContractRegistration),
            },
            etc          : {},
          },
          account            : {
            name_last : {
              required: requiredIf(this.isContractRegistration),
            },
            name_first: {
              required: requiredIf(this.isContractRegistration),
            },
            email     : {
              required: requiredIf(this.isContractRegistration),
              email,
            },
            tel       : {
              numeric,
              required: requiredIf(this.isContractRegistration),
            },
          },
          additionalAddresses: {
            maxLength: maxLength(10),
            $each    : {
              email,
              duplicateWith: duplicateWith(this.form.email),
              duplicate    : duplicateInArray(this.form.additionalAddresses),
            },
          },
        },
      }
      return validations;
    },
    created() {
      this.validateResponse = [];
      this.errorMessages    = [];
      this.initDisplay();

      window.addEventListener('message', (event) => {
        // iframe（本人認証画面）からのメッセージを受信
        if (event.data?.type === '3ds2.0Completed' && event.data.result) {
          this.creditCard3dsUrl = null;
          if (['Y', 'A'].includes(event.data.result)) {
            // 本人認証成功
            this.cardToken                                    = this.pendingCardToken;
            this.authorizedCardTokens[this.creditCardObjHash] = this.cardToken;
            this.pendingCardToken                             = null;
            this.enrollCardToken                              = null;
            this.registerOrUpdatePaymentMethod();
          } else if (['N', 'U', 'R'].includes(event.data.result)) {
            // 本人認証失敗
            this.validateResponse = [{
              target : 'card_token',
              message: Common.messages.paymentMethod.authFailed,
            }];
          } else {
            // 本人認証エラー
            this.validateResponse = [{
              target : 'card_token',
              message: Common.messages.paymentMethod.authError,
            }];
          }
          this.isCardAuthenticating = false;
        }
      });
    },
    mounted() {
      GMO.importGmoPGLibrary();
      if (this.$props.id) {
        this.gmoMemberId       = this.$props.id;
        this.showCardInfoBlock = false;
        this.getPaymentMethodDetail();
      } else {
        this.showCardInfoBlock = true;
        this.getPaymentMethods();
      }
    },
    updated() {
      if (this.checkScroll) {
        this.scrollToError();
        this.checkScroll = false;
      }
    },
    unmounted() {
      this.$v.$reset()
    },
    computed: {
      ...mapGetters('payments', {
        formData: 'formData',
      }),
      ...mapGetters('paymentNewError', {
        stateValidateResponse: 'validateResponse',
        stateErrorMessages   : 'errorMessages',
      }),
      isOpenCardAuthModal() {
        return this.creditCard3dsUrl !== null;
      },
      creditCardObj() {
        return {
          cardno      : this.form.cardNumber,
          expire      : this.form.cardExpireYear + this.form.cardExpireMonth,
          securitycode: this.form.cardSecurityCode,
          holdername  : this.form.cardHolder
        };
      },
      creditCardObjHash() {
        return btoa(JSON.stringify(this.creditCardObj));
      },
    },
    methods : {
      ...mapActions('payments', [
        'saveBack',
        'saveFormData',
      ]),
      addNewEmail(atIndex) {
        if (this.form.additionalAddresses.length >= 10) {
          return null;
        }
        this.form.additionalAddresses.splice(atIndex, 0, null);
        this.$v.form.additionalAddresses.$reset()
        this.validateResponse = this.validateResponse.filter(item => !item['target'].startsWith('additional_addresses'))
      },
      removeThisEmail(atIndex) {
        this.form.additionalAddresses.splice(atIndex, 1);
        this.$v.form.additionalAddresses.$reset()
        this.validateResponse = this.validateResponse.filter(item => !item['target'].startsWith('additional_addresses'))
      },
      getStateError() {
        if (this.stateValidateResponse || this.stateErrorMessages) {
          setTimeout(() => {
            this.validateResponse = this.stateValidateResponse ?? [];
            this.errorMessages    = this.stateErrorMessages ?? [];
            if (this.errorMessages.length > 0) {
              return;
            }
            for (let validateError of this.validateResponse) {
              if (validateError['target'] === 'card_token') {
                this.errorMessages = [validateError['message']];
                return;
              }
            }
          }, 1000)
        }
      },
      getStateForm() {
        /** ※トライアル申込内容から参照する */
        if (this.isContractRegistration()) {
          this.verify = localStorage.getItem(Common.localStorageKeys.paymentNew.verify);
          // 確認画面から戻ってきたとき
          if (this.verify && this.formData) {
            localStorage.removeItem(Common.localStorageKeys.paymentNew.verify);
            setTimeout(() => {
              this.form          = Object.assign({}, this.formData);
              if (this.formData.cardToken) {
                this.authorizedCardTokens[this.creditCardObjHash] = this.formData.cardToken;
              }
              this.oldTServiceId = this.form.t_service_id;
              this.getStateError();
            }, 100)
            return;
          }
          const authAccount                 = JSON.parse(localStorage.getItem(Common.localStorageKeys.user.auth));
          this.form.corporation.name        = authAccount.corporation.name ?? null;
          this.form.corporation.branch_name = authAccount.corporation.branch_name ?? null;
          this.form.account.email           = authAccount.corporation.contacts[0].email ?? (authAccount.email ?? null);
          this.form.account.tel             = authAccount.corporation.contacts[0].tel ?? null;
          this.form.account.name_last       = authAccount.name_last ?? null;
          this.form.account.name_first      = authAccount.name_first ?? null;
        }
      },
      initDisplay() {
        apiClient.get(apiList.accounts.status)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.isTrialUser = (response.data.status === Common.trialStatus);
            this.isTrialEnd  = (response.data.status === Common.trialEndedStatus);
            if (this.isTrialUser || this.isTrialEnd) {
              this.form.label = Common.messages.paymentSetting.nameDefault;
            }
          })
          .catch(error => {
            this.errorMessages = [error.message];
          });
      },
      backToList() {
        const nextRoute = (!this.$props.id && this.paymentMethods === null) ? 'BackendUserContractFlow' : 'BackendUserPayments';
        if (nextRoute === 'BackendUserPayments') {
          this.saveBack(true);
        }
        this.$router.replace({name: nextRoute}).then();
      },
      errorNotFound() {
        if (this.$props.id) {
          if (!this.gmoMemberId) {
            this.errorMessages = [Common.messages.paymentMethod.notFound];
            return true;
          }
        }
        return false;
      },
      getPaymentMethods() {
        this.paymentMethods = null;
        this.loadDetail     = true;
        apiClient.get(apiList.payment.payment_methods.list)
          .then(response => {
            const result = response.data;
            if (result.errors) {
              return;
            }
            if (result.data && result.data.length > 0) {
              this.paymentMethods = result.data;
            }
          })
          .catch(error => {
          })
          .finally(() => {
            this.loadDetail  = false;
            this.fetchDetail = true;
            if (this.isContractRegistration()) {
              this.getStateForm();
            }
          });
      },
      onChangeBillingMethod: function () {
        if (this.form.bill_method === Common.billingMethodCreditCard) {
          this.form.bill_via = Common.billingViaEmail;
        }
      },
      showViaItem          : function (item) {
        return this.form.bill_method !== Common.billingMethodCreditCard || item === Common.billingViaEmail;
      },
      showCardInformation() {
        return this.form.bill_method === Common.billingMethodCreditCard;
      },
      getEmailValidationClass(index) {
        if (!this.$v.form.additionalAddresses) {
          return null;
        }
        if (!this.$v.form.additionalAddresses.$each[index]) {
          return null;
        }
        const emailValidate = this.$v.form.additionalAddresses.$each[index];
        if (emailValidate.$invalid === true && emailValidate.$dirty === true) {
          return {
            'md-invalid': true,
          }
        }
        const responseMessage = this.getEmailValidationResponseMessage(index)
        return {
          'md-invalid': responseMessage !== null,
        }
      },
      getEmailValidationResponseMessage(index) {
        return this.getValidationResponseMessage('additional_addresses.' + index)
      },
      validateForm() {
        this.$v.form.$reset();
        this.$v.form.label.$touch();
        this.$v.form.bill_method.$touch();
        this.$v.form.bill_via.$touch();
        this.$v.form.name1.$touch();
        this.$v.form.postal.$touch();
        this.$v.form.pref.$touch();
        this.$v.form.city.$touch();
        this.$v.form.street_name.$touch();
        this.$v.form.street_number.$touch();
        this.$v.form.email.$touch();
        this.$v.form.t_service_id.$touch();
        this.$v.form.activated.$touch();
        this.$v.form.apply.$touch();
        if (this.isContractRegistration()) {
          this.$v.form.corporation.$touch();
          this.$v.form.account.$touch();
        }
        this.$v.form.additionalAddresses.$touch();

        let invalid = this.$v.form.label.$invalid
          || this.$v.form.bill_method.$invalid
          || this.$v.form.bill_via.$invalid
          || this.$v.form.name1.$invalid
          || this.$v.form.postal.$invalid
          || this.$v.form.pref.$invalid
          || this.$v.form.city.$invalid
          || this.$v.form.street_name.$invalid
          || this.$v.form.street_number.$invalid
          || this.$v.form.email.$invalid
          || this.$v.form.t_service_id.$invalid
          || this.$v.form.activated.$invalid
          || this.$v.form.apply.$invalid
          || this.$v.form.corporation.$invalid
          || this.$v.form.account.$invalid
          || this.$v.form.additionalAddresses.$invalid
        ;

        if (this.showCardInformation() && (this.$props.id === null || this.oldBillMethod !== this.form.bill_method)) {
          this.$v.form.cardNumber.$touch();
          this.$v.form.cardExpireMonth.$touch();
          this.$v.form.cardExpireYear.$touch();
          this.$v.form.cardHolder.$touch();
          this.$v.form.cardSecurityCode.$touch();
          invalid = invalid
            || this.$v.form.cardNumber.$invalid
            || this.$v.form.cardExpireMonth.$invalid
            || this.$v.form.cardExpireYear.$invalid
            || this.$v.form.cardHolder.$invalid
            || this.$v.form.cardSecurityCode.$invalid;
        }
        return invalid === false;
      },
      submitForm: function () {
        this.removeValidationResponseMessage('card_token');
        if (this.validateForm()) {
          this.cardToken = null;
          if (this.form.apply === false && !this.$props.id && this.paymentMethods === null) {
            // 利用規約の確認がチェックされているか（本契約時のみ確認する）
            this.validateResponse.push({
              target : 'apply',
              message: Common.messages.requestTrial.acceptTermMessage
            });
          } else if (this.form.cardNumber && this.showCardInformation()) {
            this.startCreditCard3ds();
          } else {
            this.registerOrUpdatePaymentMethod();
          }
        } else {
          this.checkScroll = true;
        }
      },
      years() {
        let maxYear = moment().add(10, 'years').year();
        let minYear = moment().subtract(50, 'years').year();
        return _.range(maxYear, minYear, -1);
      },
      getPaymentMethodDetail() {
        this.successMessage = null;
        this.loadDetail     = true;
        const detailUrl     = apiList.payment.payment_methods.detail.replace(':gmo_member_id', this.gmoMemberId);
        this.gmoMemberId    = null;
        apiClient.get(detailUrl)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.parsePaymentMethodDetail(response.data);
            this.paymentMethods = [response.data];
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.loadDetail  = false;
            this.fetchDetail = true;
          });
      },
      parsePaymentMethodDetail(responseData) {
        this.gmoMemberId              = responseData.gmo_member_id;
        this.form.label               = responseData.label;
        this.form.bill_method         = responseData.bill_method.toString();
        this.oldBillMethod            = responseData.bill_method.toString();
        this.form.bill_via            = responseData.bill_via.toString();
        // Address information
        this.form.name1               = responseData.billing_address.name1;
        this.form.name2               = responseData.billing_address.name2;
        this.form.name3               = responseData.billing_address.name3;
        this.form.postal              = responseData.billing_address.postal;
        this.form.pref                = responseData.billing_address.pref;
        this.form.city                = responseData.billing_address.city;
        this.form.street_name         = responseData.billing_address.street_name;
        this.form.street_number       = responseData.billing_address.street_number;
        this.form.etc                 = responseData.billing_address.etc;
        // Email
        this.form.email               = responseData.email;
        this.form.additionalAddresses = [null];
        if (responseData.additional_addresses && responseData.additional_addresses.length) {
          this.form.additionalAddresses = responseData.additional_addresses
        }
        // Show card info block
        if (this.form.bill_method !== Common.billingMethodCreditCard) {
          this.showCardInfoBlock = true;
        }
      },
      createFormData() {
        const form = {
          label        : this.form.label,
          bill_via     : this.form.bill_via,
          name1        : this.form.name1,
          name2        : this.form.name2,
          name3        : this.form.name3,
          postal       : this.form.postal,
          pref         : this.form.pref,
          city         : this.form.city,
          street_name  : this.form.street_name,
          street_number: this.form.street_number,
          etc          : this.form.etc,
          email        : this.form.email,
          meta         : {
            account_id: Common.getCurrentUserInfo().id,
          },
        };

        form.additional_addresses     = this.form.additionalAddresses.filter(email => email).map(email => email);

        // Check register or change bill method
        if (this.$props.id === null ||
          this.oldBillMethod !== this.form.bill_method ||
          (this.form.bill_method === Common.billingMethodCreditCard && this.cardToken)) {
          form.bill_method = this.form.bill_method;
          if (this.cardToken) {
            form.card_token = this.cardToken;
          }
        }
        return form;
      },
      initForm() {
        this.form = {
          label           : null,
          bill_method     : Common.billingMethodCreditCard,
          cardNumber      : null,
          cardExpireMonth : null,
          cardExpireYear  : moment().year(),
          cardHolder      : null,
          cardSecurityCode: null,
          bill_via        : Common.billingViaEmail,
          name1           : null,
          name2           : null,
          name3           : null,
          postal          : null,
          email           : null,
          pref            : null,
          city            : null,
          street_name     : null,
          street_number   : null,
          etc             : null,
          contract        : {
            reason: Common.contractReason[0],
          },
        };
      },
      /**
       * 更新処理
       */
      updatePaymentMethod() {
        this.sending          = true;
        this.validateResponse = [];
        const url             = apiList.payment.payment_methods.update.replace(':gmo_member_id', this.gmoMemberId);
        apiClient.put(url, this.createFormData())
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.parsePaymentMethodDetail(response.data);
            if (this.gmoMemberId) {
              this.successMessage = Common.messages.paymentMethod.updateSuccess;
              this.setSnackBar(Common.messages.paymentMethod.updateSuccess);
              this.saveBack(true);
              this.$router.replace({name: 'BackendUserPayments'});
            } else {
              this.errorMessages = [Common.messages.paymentMethod.updateError];
            }
          })
          .catch(error => {
            this.errorMessages = [error.message];
            this.$v.$reset();
          })
          .finally(() => {
            this.sending     = false;
            this.checkScroll = true;
          });
      },
      /**
       * 登録処理
       */
      registerPaymentMethod() {
        this.sending          = true;
        this.validateResponse = [];
        if (this.isContractRegistration()) {
          const form     = Object.assign({}, this.form);
          form.cardToken = this.cardToken;
          this.saveFormData(form);
          return this.$router.push({name: 'BackendUserPaymentContractPreview'}).then();
        }
        apiClient.post(apiList.payment.payment_methods.register, this.createFormData())
          .then(response => {
            if (this.hasResponseErrors(response)) {
              this.$v.$reset();
              this.sending = false;
              return;
            }
            this.parsePaymentMethodDetail(response.data);
            if (this.gmoMemberId) {
              this.sending = false;
              this.initForm();
              this.gmoMemberId = null;
              this.setSnackBar(Common.messages.paymentMethod.insertSuccess);
              this.saveBack(true);
              this.$router.replace({name: 'BackendUserPayments'});
            } else {
              this.errorMessages = [Common.messages.paymentMethod.insertError];
              this.sending       = false;
            }
          })
          .catch(error => {
            this.errorMessages = [error.message];
            this.$v.$reset();
            this.sending = false;
          })
          .finally(() => {
            this.checkScroll = true;
          });
      },
      registerOrUpdatePaymentMethod() {
        this.errorMessages = [];
        if (this.$props.id) {
          this.updatePaymentMethod();
        } else {
          this.registerPaymentMethod();
        }
      },
      openDialog() {
        this.$v.form.t_service_id.$touch();
        if (this.$v.form.t_service_id.$invalid) {
          return;
        }
        this.showDialog = true;
      },
      getActivationValidationClass() {
        const tServiceValidation = this.getValidationClass('t_service_id');
        if (tServiceValidation["md-invalid"]) {
          return tServiceValidation;
        }
        return this.getValidationClass('activated');
      },
      closeActivationModal() {
        this.showDialog = false;
      },
      activationSuccess() {
        this.showDialog = false;
        this.duplicateDetection();
      },
      duplicateDetection() {
        apiClient
          .get(apiList.accounts.duplicateDetection, {
            params: {t_service_id: this.form.t_service_id}
          })
          .then(response => {
            if (this.hasResponseErrors(response)) {
              this.form.activated = null;
              return;
            }
            this.oldTServiceId  = this.form.t_service_id;
            this.form.activated = true;
          })
          .catch(error => {
            this.errorMessages  = [error.message];
            this.form.activated = null;
          });
      },
      /**
       * 登録完了メッセージダイアログを閉じる（本契約時のみ）
       */
      closeRegisteredDialog() {
        // 左メニューなどを再読込させるため暫定的な対応
        window.location.href = '/user/payments';
      },
      scrollToError() {
        let selectorInvalid = this.$el.querySelector(".md-invalid");
        if (selectorInvalid !== null) {
          this.scrollToSelector(selectorInvalid);
          return;
        }
        let selectorFlashError = this.$el.querySelector(".flash-error-message");
        if (selectorFlashError !== null) {
          this.scrollToSelector(selectorFlashError);
        }
      },
      /**
       * 利用規約を開く
       */
      openTerms() {
        window.open('/terms', '_blank');
        this.isReadTerms = true;
      },
      /**
       * 支払情報に登録されているカード番号（末尾の数字のみ）
       */
      paymentMethodCardNo() {
        if (!this.paymentMethods || !this.paymentMethods[0] || !this.paymentMethods[0].card) {
          return '(未登録)';
        }
        const expire = this.paymentMethods[0].card.expire;
        const cardNo = this.paymentMethods[0].card.no;
        return '(末尾：' + cardNo.replace(/\*/g, '') + '　有効期限：' + this.formatCardExpire(expire) + ')';
      },
      /**
       * カードの有効期限を整形する（2201 -> 01/2022)
       */
      formatCardExpire(rawCardExpire) {
        if (!rawCardExpire && rawCardExpire.length !== 4) {
          return '';
        }
        return rawCardExpire.substr(2, 2)
          + '/20'
          + rawCardExpire.substr(0, 2);
      },
      /**
       * Copy corporation info into address payment
       */
      copyCorporationInformation: function () {
        if (this.isSameCorporation) {
          this.form.postal        = this.form.corporation.postal;
          this.form.pref          = this.form.corporation.pref;
          this.form.city          = this.form.corporation.city;
          this.form.street_name   = this.form.corporation.street_name;
          this.form.street_number = this.form.corporation.street_number;
          this.form.etc           = this.form.corporation.etc;
          this.form.email         = this.form.account.email;
        }
      },
      isContractRegistration() {
        return !this.$props.id && this.paymentMethods === null;
      },
      disabledByTServiceId() {
        return this.isContractRegistration() && !this.form.activated;
      },
      /**
       * 入力コンテンツの無効化
       * @returns {boolean}
       */
      contentDisabled() {
        // 編集画面 もしくは2回目の支払い方法の登録が2回目の場合は登録済みなので、入力コンテンツを有効化
        if (this.paymentMethods !== null || this.$props.id !== null) {
          return false;
        }

        // トライアル期間中である場合、未アクティベーションであれば、入力コンテンツを無効化
        if (this.isTrialUser || this.isTrialEnd) {
          return !this.form.activated;
        }

        // 上記以外は入力コンテンツを無効化
        return true;
      },
      /**
       * 支払情報の名称を表示するか
       * @returns {boolean}
       */
      showPaymentLabel() {
        // 編集画面 もしくは2回目の支払い方法の登録が2回目の場合は登録済みなので、表示する
        if (this.paymentMethods !== null || this.$props.id !== null) {
          return true;
        }

        // トライアル期間中である場合、初回登録：デフォルト値であるため、非表示にする
        if (this.isTrialUser || this.isTrialEnd) {
          return false;
        }

        // 上記以外は表示する
        return true;
      },
      /**
       * 法人情報と同じを表示するか
       * @returns {boolean}
       */
      showAddressCopy() {
        // 2回目の支払い方法の登録の場合は、法人情報がないため非表示にする
        if (this.paymentMethods !== null) {
          return false;
        }

        // 新規登録の場合は、表示する
        if (this.$props.id === null) {
          return true;
        }

        // トライアル期間中である場合、初回登録であるため、表示する
        if (this.isTrialUser || this.isTrialEnd) {
          return false;
        }

        // 上記以外は非表示にする
        return false;
      },
      /**
       * クレカの本人認証を開始する
       * @returns {Promise<void>}
       */
      async startCreditCard3ds() {
        if (this.isCardAuthenticating) {
          return;
        }
        this.isCardAuthenticating = true;

        let authorizedCardToken = this.authorizedCardTokens[this.creditCardObjHash];

        if (authorizedCardToken) {
          this.cardToken = authorizedCardToken;
          this.registerOrUpdatePaymentMethod();
          this.isCardAuthenticating = false;
          return;
        }

        try {
          const response        = await GMO.getToken(this.creditCardObj, 2)
          this.pendingCardToken = response.tokenObject.token[0];
          this.enrollCardToken  = response.tokenObject.token[1];
          console.debug(`保留中のカードトークン: ${this.pendingCardToken}`);
        } catch {
          this.validateResponse     = [{
            target : 'card_token',
            message: Common.messages.paymentMethod.cardNotValid,
          }];
          this.isCardAuthenticating = false;
          return;
        }

        // ** 本人認証プロセスの開始 **

        const user = Common.getCurrentUserInfo();

        // 項目はGMO-PGのドキュメントを参照
        // https://gmopg_docs:PF%cwa$GmCC@docs.mul-pay.jp/payment/credit/api3ds2#exectran
        const card3dsParams = {
          Tds2ThreeDSReqAuthMethod: '02',
          Tds2Email               : user.email,
          Tds2BillAddrCountry     : '392',
        };
        // 郵便番号
        if (this.form.corporation.postal) {
          card3dsParams.Tds2BillAddrPostCode = this.form.corporation.postal;
        } else if (user.corporation.postal) {
          card3dsParams.Tds2BillAddrPostCode = user.corporation.postal;
        }
        // 都道府県番号
        if (this.form.corporation.pref) {
          card3dsParams.Tds2BillAddrState = Common.prefNameToCode(this.form.corporation.pref);
        } else if (user.corporation.pref) {
          card3dsParams.Tds2BillAddrState = Common.prefNameToCode(user.corporation.pref);
        }
        // 市区町村
        if (this.form.corporation.city) {
          card3dsParams.Tds2BillAddrCity = this.form.corporation.city;
        } else if (user.corporation.city) {
          card3dsParams.Tds2BillAddrCity = user.corporation.city;
        }
        // 町域・丁目番地
        if (this.form.corporation.street_name) {
          card3dsParams.Tds2BillAddrLine1 = this.form.corporation.street_name + (this.form.corporation.street_number || '');
        } else if (user.corporation.street_name) {
          card3dsParams.Tds2BillAddrLine1 = user.corporation.street_name + (user.corporation.street_number || '');
        }
        // 建物・号室
        if (this.form.corporation.etc) {
          card3dsParams.Tds2BillAddrLine2 = this.form.corporation.etc;
        } else if (user.corporation.etc) {
          card3dsParams.Tds2BillAddrLine2 = user.corporation.etc;
        }

        // APIリクエスト
        const {data, status} = await apiClientWithoutToken.post(apiList.payment.card3ds.start, {
          card_token       : this.pendingCardToken,
          enroll_card_token: this.enrollCardToken,
          card_3ds_params  : card3dsParams,
        })

        // HTTP 200 以外の場合、エラー
        if (status !== 200) {
          this.validateResponse     = [{
            target : 'card_token',
            message: Common.messages.paymentMethod.authError,
          }];
          this.isCardAuthenticating = false;
          return;
        }

        // 認証用URLが設定されている場合、本人認証画面（CreditCard3dsModal）を開く
        if (data.auth_url) {
          this.creditCard3dsUrl = data.auth_url;
          return;
        }

        if (data.errors) {
          // ** 通常オーソリ失敗 **
          this.validateResponse = data.errors;
        } else {
          // ** 通常オーソリ成功 **
          console.debug('3DS2.0未対応のクレジットカードです');
          this.cardToken                                    = this.pendingCardToken;
          this.authorizedCardTokens[this.creditCardObjHash] = this.cardToken;
          this.pendingCardToken                             = null;
          this.enrollCardToken                              = null;
          this.registerOrUpdatePaymentMethod();
        }
        this.isCardAuthenticating = false;
      },
      /**
       * クレカ本人認証モーダルが閉じられたときの処理
       */
      handleCloseCardAuthModal() {
        this.creditCard3dsUrl     = null;
        this.isCardAuthenticating = false;
      },
    },
    watch   : {
      "form.postal"            : function (pCode) {
        if (!pCode) {
          this.form.postal = '';
          return false;
        }

        const field = this.$v.form['postal'];
        if (field.$invalid === true && field.$dirty === true) {
          return;
        }
        let _this = this;
        new YubinBango.Core(pCode, function (addr) {
          if (addr.region.length === 0) {
            return;
          }
          if ((_this.form.city !== null && _this.form.city !== '')
            || (_this.form.street_name !== null && _this.form.street_name !== '')) {
            return;
          }
          _this.form.pref        = addr.region;
          _this.form.city        = addr.locality;
          _this.form.street_name = addr.street;
        });

        this.form.postal = pCode.match(/\d/ig) ? pCode.match(/\d/ig).join('') : '';
      },
      "form.corporation.postal": function (pCode) {
        if (!pCode) {
          this.form.corporation.postal = '';
          this.copyCorporationInformation();
          return false;
        }

        const field = this.$v.form.corporation['postal'];
        if (field.$invalid === true && field.$dirty === true) {
          return;
        }
        let _this = this;
        new YubinBango.Core(pCode, function (addr) {
          if (addr.region.length === 0) {
            return;
          }
          if ((_this.form.corporation.city !== null && _this.form.corporation.city !== '')
            || (_this.form.corporation.street_name !== null && _this.form.corporation.street_name !== ''
            )) {
            return;
          }
          _this.form.corporation.pref        = addr.region;
          _this.form.corporation.city        = addr.locality;
          _this.form.corporation.street_name = addr.street;
        });

        this.form.corporation.postal = pCode.match(/\d/ig) ? pCode.match(/\d/ig).join('') : '';
      },
      "form.corporation.pref"  : function () {
        this.copyCorporationInformation();
      },
      "form.corporation.city"  : function () {
        this.copyCorporationInformation();
      },
      "form.corporation.town"  : function () {
        this.copyCorporationInformation();
      },
      "form.corporation.etc"   : function () {
        this.copyCorporationInformation();
      },
      "form.corporation.email" : function () {
        this.copyCorporationInformation();
      },
      "form.t_service_id"      : function (newValue, oldValue) {
        if (!this.oldTServiceId) {
          return;
        }
        if (newValue === this.oldTServiceId) {
          this.form.activated = true;
        } else {
          this.form.activated = null;
        }
      },
      "form.bill_method"       : function (newValue, oldValue) {
        this.removeValidationResponseMessage('card_token');
      },
      /**
       * カード情報更新時にカードトークンに関するエラーをクリア
       *
       * @param newValue
       * @param oldValue
       */
      "form.cardNumber": function (newValue, oldValue) {
        this.removeValidationResponseMessage('card_token');
      },
      /**
       * カード情報更新時にカードトークンに関するエラーをクリア
       *
       * @param newValue
       * @param oldValue
       */
      "form.cardExpireMonth": function (newValue, oldValue) {
        this.removeValidationResponseMessage('card_token');
      },
      /**
       * カード情報更新時にカードトークンに関するエラーをクリア
       *
       * @param newValue
       * @param oldValue
       */
      "form.cardExpireYear": function (newValue, oldValue) {
        this.removeValidationResponseMessage('card_token');
      },
      /**
       * カード情報更新時にカードトークンに関するエラーをクリア
       *
       * @param newValue
       * @param oldValue
       */
      "form.cardHolder": function (newValue, oldValue) {
        this.removeValidationResponseMessage('card_token');
        this.form.cardHolder = newValue.replace('　', ' ');
      },
      /**
       * カード情報更新時にカードトークンに関するエラーをクリア
       *
       * @param newValue
       * @param oldValue
       */
      "form.cardSecurityCode": function (newValue, oldValue) {
        this.removeValidationResponseMessage('card_token');
      },
      /**
       * Copy corporation info into address payment
       */
      isSameCorporation: function () {
        this.copyCorporationInformation();
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "src/assets/scss/components.scss";

  .pointer {
    cursor: pointer;
  }

  .mg-l-20 {
    margin-left: 20px;
  }

  .md-checked {
    color: #ff5252 !important;
  }

  .md-checkbox-checked {
    color: #44D644 !important;
  }

  .check-same-corp {
    margin-top: 16px;
  }

  button.check-same-corp {
    margin-left: 0;
    margin-top: 0;
  }

  .md-card-content-disabled {
    background-color: #f8f8f8;
  }

  @media screen and (max-width: 1024px) {
    .check-same-corp {
      i {
        display: none;
      }
    }
  }

  .md-corp-num {
    position: absolute;
    right: 0;
    padding-right: 60px;
    margin-top: -10px;
  }
</style>
